// Sticky CTA visibility
const hero = document.getElementById('heroBuyBox');
const sticky = document.getElementById('stickyCta');
const observer = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if(!e.isIntersecting && e.boundingClientRect.top < 0) sticky.classList.add('visible');
    else sticky.classList.remove('visible');
  });
}, { threshold: 0 });
observer.observe(hero);

// FAQ accordion
document.querySelectorAll('.faq-q').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.parentElement.classList.toggle('open');
  });
});

// Lightbox for gallery
function ssOpenLightbox(src){
  const lb = document.getElementById('ssLightbox');
  document.getElementById('ssLightboxImg').src = src;
  lb.classList.add('open');
}
document.addEventListener('keydown', (e) => {
  if(e.key === 'Escape') document.getElementById('ssLightbox').classList.remove('open');
});